import { CARTRIDGE_TYPE } from '@models/CartridgeType';
import { ArrowCartridge } from './ArrowCartridge';
import { FireballCartridge } from './FireballCartridge';
var CartridgeFactory = /** @class */ (function () {
    function CartridgeFactory() {
    }
    CartridgeFactory.createCartridge = function (cartridgeType, x, y) {
        switch (cartridgeType) {
            case CARTRIDGE_TYPE.ARROW:
                return new ArrowCartridge(x, y);
            case CARTRIDGE_TYPE.FIREBALL:
                return new FireballCartridge(x, y);
            default:
                return new ArrowCartridge(x, y);
        }
    };
    return CartridgeFactory;
}());
export { CartridgeFactory };
